import type { Story } from '@/store/story-types'

export const DIGITAL_ACADEMY_STORY: Story = {
  id: 'digital-academy',
  name: 'ACADEMY — Learn & Create',
  narrative: 'An influencer digital education platform offering courses, downloadable presets and resources, progress tracking, and certificates upon completion.',
  goals: ['Browse courses', 'Enroll in a course', 'Track learning progress', 'Download resources and earn certificates'],
  lifecycle: 'building',
  pages: [
    {
      id: 'pg-home', title: 'Home', order: 0, status: 'draft', elementCount: 4, linkedPageId: 'home',
      description: 'Landing page with hero banner and course catalog grid',
      blockRef: { category: 'k-commerce', blockId: 'hero-banner' },
    },
    {
      id: 'pg-course', title: 'Course Detail', order: 1, status: 'draft', elementCount: 3, linkedPageId: 'course',
      description: 'Course detail page with curriculum, instructor info, and enroll button',
      blockRef: { category: 'k-commerce', blockId: 'course-detail' },
    },
    {
      id: 'pg-learning', title: 'My Learning', order: 2, status: 'draft', elementCount: 4, linkedPageId: 'learning',
      description: 'Learning dashboard with lesson progress and downloadable resource library',
      blockRef: { category: 'k-commerce', blockId: 'lesson-progress' },
    },
    {
      id: 'pg-cart', title: 'Cart', order: 3, status: 'draft', elementCount: 3, linkedPageId: 'cart',
      description: 'Cart and checkout for course enrollment payment',
      blockRef: { category: 'k-commerce', blockId: 'cart-checkout' },
    },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'Browse Courses',
      description: 'Visitor browses the available course catalog',
      steps: [
        { type: 'given', text: 'the visitor is on the home page' },
        { type: 'when', text: 'the page loads' },
        { type: 'then', text: 'a course catalog grid with titles, thumbnails, and prices is visible', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'View Course Detail',
      description: 'Visitor views a specific course with curriculum and instructor info',
      steps: [
        { type: 'given', text: 'the visitor taps a course card' },
        { type: 'when', text: 'the course detail page loads', linkedPageId: 'course' },
        { type: 'then', text: 'the curriculum outline, instructor bio, reviews, and an enroll button are displayed' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'Enroll in Course',
      description: 'Visitor enrolls in a course through the checkout flow',
      steps: [
        { type: 'given', text: 'the visitor is on the course detail page', linkedPageId: 'course' },
        { type: 'when', text: 'they tap the Enroll button' },
        { type: 'then', text: 'the course is added to the cart', linkedPageId: 'cart' },
        { type: 'and', text: 'payment is processed and enrollment is confirmed', linkedFlowId: 'processEnrollment' },
      ],
    },
    {
      id: 'bdd-4',
      name: 'Track Learning Progress',
      description: 'Student views their learning progress and downloads resources',
      steps: [
        { type: 'given', text: 'the student is enrolled in a course' },
        { type: 'when', text: 'they navigate to My Learning', linkedPageId: 'learning' },
        { type: 'then', text: 'lesson progress bars, completed lessons, and a download library are displayed' },
      ],
    },
    {
      id: 'bdd-5',
      name: 'Earn Certificate',
      description: 'Student completes all lessons and receives a certificate',
      steps: [
        { type: 'given', text: 'the student has completed all lessons in a course', linkedPageId: 'learning' },
        { type: 'when', text: 'the last lesson is marked complete' },
        { type: 'then', text: 'a completion certificate is generated and available for download' },
      ],
    },
  ],
}
